<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>Adicionar unidade</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="flex-column mt-2 col-md-12">
      <mat-form-field id="field-codigo" class="width-100" appearance="outline">
        <mat-label>Sigla</mat-label>
        <input
          matInput
          (blur)="verificarSigla()"
          [formControl]="form.get('sigla')"
          type="text"
          mask="SSS"
          [value]="form.get('sigla').value | uppercase"
          autocomplete="off"
          name="soasigla"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('sigla').touched && form.get('sigla').hasError('required')
        "
      >
        {{ displayMessages.sigla.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('sigla').touched && form.get('sigla').hasError('repeated')
        "
      >
        {{ displayMessages.sigla.repeated }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('sigla').touched && form.get('sigla').hasError('maxlength')
        "
      >
        {{ displayMessages.sigla.maxlength }}
      </small>
    </div>
    <div class="flex-column mt-2 col-md-12">
      <mat-form-field id="field-codigo" class="width-100" appearance="outline">
        <mat-label>Nome</mat-label>
        <input
          type="text"
          matInput
          [formControl]="form.get('nome')"
          (blur)="verificarNome()"
          autocomplete="off"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('required')
        "
      >
        {{ displayMessages.nome.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('repeated')
        "
      >
        {{ displayMessages.nome.repeated }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('maxlength')
        "
      >
        {{ displayMessages.nome.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('isEmptyValue')
        "
      >
        {{ displayMessages.nome.isEmptyValue }}
      </small>
    </div>
    <div class="flex-column flex align-items-center">
      <div class="mt-2 col-md-12" *ngIf="usaFiscal">
        <fast-autocomplete
          [autoFirst]="false"
          id="field-forma-pagto"
          placeholder="Unidade de medida"
          displayField="sigla"
          [control]="form.get('unidade_medida')"
          (clearSelection)="form.get('unidade_medida').reset()"
          [entityService]="unidadeMedidaService"
          [initDataWithEmpty]="true"
          [messages]="{
            typeIs: 'Valor inválido',
            required: 'Unidade de medida é obrigatório',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
        ></fast-autocomplete>
      </div>
      <div class="flex mt-2 col-md-12 p-0 justify-content-start">
        <mat-checkbox
          color="primary"
          class="mt-2 col-md-6 mt-2"
          [formControl]="form.get('fracionado')"
        >
          Unidade Fracionada
        </mat-checkbox>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="mt-2 col-md-12 pb-2 flex justify-content-end">
      <button
        [disabled]="loading"
        mat-stroked-button
        color="warn"
        (click)="dialogRef.close()"
      >
        Cancelar
      </button>
      <button
        [disabled]="loading || !form.valid"
        mat-raised-button
        color="primary"
        (click)="submit()"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
